export const environment = {
  production: false,
  env: 'Testing'
};
